import { Button, CircularProgress, Typography } from "@material-ui/core";
import { ThemeProvider, makeStyles } from "@material-ui/core/styles";
import { ITheme, theme } from "../constants/theme";
import { buttonHoverAndActive } from "../utils/styles/buttonStyles";

const ButtonWithLoadingIndicator = (props: any) => {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <Button
        {...props}
        variant="contained"
        disableElevation
        className={classes.primaryButton}
        style={{ paddingLeft: props.loading ? "12px" : "16px" }}
        onClick={props.onClick}
        disabled={props.disabled}
        type={props.type}
      >
        {props.loading ? (
          <CircularProgress
            color="inherit"
            size={18}
            className={classes.circularProgress}
          />
        ) : (
          <></>
        )}
        <Typography variant="button" component="p">
          {props.title}
        </Typography>
      </Button>
    </ThemeProvider>
  );
};

const useStyles = makeStyles((theme: ITheme) => ({
  primaryButton: {
    justifyContent: "center",
    paddingTop: 6,
    paddingBottom: 6,
    paddingRight: 16,
    borderRadius: "8px",
    ...buttonHoverAndActive
  },
  circularProgress: {
    marginRight: "8px",
  },
}));
export default ButtonWithLoadingIndicator;
